<template>
    <div class="modal modal-confirm fade" id="registerConfirmModal" tabindex="-1" role="dialog" aria-labelledby="registerConfirmModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Thank You!</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>Now we will redirect you to DocuSign to get your e-signature</p>
                    <a href="javascript:void(0)" class="btn d-flex justify-content-center mt-5" @click="login">OK</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RegisterConfirmModal",
        methods: {
            login() {
                $('#registerConfirmModal').hide();

                setTimeout(() => {
                    window.location.href = '/docusign/init'
                }, 500);
            }
        }
    }
</script>
